import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ProcessScreenComponent } from 'src/app/account/process-screen/process-screen.component';
import { LoaderService } from 'src/app/services/loader.service';
import {
  BankDetail,
  BankDetailResponse,
  WalletStore,
  BankResponse,
  BankData,
} from 'src/app/stores/wallet.store';
import { PaymentSuccessModalComponent } from '../payment-success-modal/payment-success-modal.component';

@Component({
  selector: 'app-bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.scss'],
})
export class BankTransferComponent implements OnInit {
  validations_form: FormGroup;
  validation_errors: any;
  bankDetail: BankDetail;
  bankList: Array<BankData>;
  constructor(
    private modalCtrl: ModalController,
    private FormBuilder: FormBuilder,
    private loaderService: LoaderService,
    private walletStore: WalletStore,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.getBankResponse();
    this.refreshForm();
    this.getBankDetail();
  }
  async getBankResponse() {
    var response: BankResponse = await this.walletStore.getBanks();
    this.bankList = response.data;
    this.refreshForm();
  }
  async getBankDetail() {
    var response: BankDetailResponse = await this.walletStore.getBankDetail();
    this.bankDetail = response.data;
    this.refreshForm();
  }
  ionViewDidEnter() {}

  refreshForm() {
    this.getErrors();
    this.validations_form = this.FormBuilder.group({
      type: new FormControl('1'),
      amount: new FormControl('', Validators.compose([Validators.required])),
      bank_account_name: new FormControl(
        this.bankDetail ? this.bankDetail?.bank_account_name : '',
        Validators.compose([Validators.required])
      ),
      bank_code: new FormControl(
        this.bankDetail ? this.bankDetail?.bank_code : '',
        Validators.compose([Validators.required])
      ),
      bank_iban: new FormControl(
        this.bankDetail ? this.bankDetail?.bank_iban.slice(4) : '',
        Validators.compose([Validators.required])
      ),
    });
  }

  getErrors() {
    this.validation_errors = {
      amount: [
        {
          type: 'required',
          message: `FINANCE.ADD_MONEY_ERROR`,
        },
      ],
      bank_account_name: [
        {
          type: 'required',
          message: `INDIVIDUAL_SELLER.BANK_NAME_REQUIRED`,
        },
      ],
      bank_code: [
        { type: 'required', message: `PLACEHOLDER_TEXT.BANK_CODE_REQ` },
      ],
      bank_iban: [
        {
          type: 'required',
          message: `INDIVIDUAL_SELLER.BANK_ACCOUNT_REQUIRED`,
        },
      ],
    };
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  async submit() {
    this.loaderService.showLoading();

    var modifiedValue =
      this.validations_form.value?.bank_iban?.trim()?.toUpperCase() || '';
    if (modifiedValue?.startsWith('AO06')) {
      modifiedValue = modifiedValue?.slice(4);
    }

    try {
      let payload = {
        type: this.validations_form.value.type,
        amount: this.validations_form.value.amount,
        bank_account_name: this.validations_form.value.bank_account_name,
        bank_code: this.validations_form.value.bank_code,
        bank_iban: 'AO06' + modifiedValue,
      };
      var resp: any = await this.walletStore.addMoneyToBank(payload);
      if (resp.data) {
        this.modalCtrl.dismiss();
        this.loaderService.dismissLoading();
        // var checkPayment = true;
        // this.getUrl(checkPayment, resp.data.reference_id);
        this.getUrl();
      }
      this.loaderService.dismissLoading();
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        this.translate.instant(
          error.error.data ? error.error.data : 'FINANCE.PAYMENT_FAILED'
        ),
        'middle',
        'danger',
        3000
      );
    }
  }

  // checkPayment: boolean, reference_id: number
  async getUrl() {
    const modal = await this.modalCtrl.create({
      component: PaymentSuccessModalComponent,
      cssClass: 'Successful-Created',
      backdropDismiss: true,
    });
    modal.present();
    const resp = await modal.onDidDismiss();
  }
}
